// extracted by mini-css-extract-plugin
export var author = "bullet-list-module--author--5ddbe";
export var bulletList = "bullet-list-module--bullet-list--71531";
export var category = "bullet-list-module--category--e95a6";
export var headline = "bullet-list-module--headline--0cad0";
export var headlinePost = "bullet-list-module--headline-post--036b3";
export var list = "bullet-list-module--list--7cbc0";
export var listItem = "bullet-list-module--listItem--e5ec8";
export var markdownComponent = "bullet-list-module--markdown-component--eab69";
export var paragraph = "bullet-list-module--paragraph--aa283";